export * from './typedsocket.classes.typedsocket.js';